import { render } from "./PriceLogs.vue?vue&type=template&id=6b51976a&scoped=true"
import script from "./PriceLogs.vue?vue&type=script&lang=js"
export * from "./PriceLogs.vue?vue&type=script&lang=js"

import "./PriceLogs.vue?vue&type=style&index=0&id=6b51976a&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b51976a"]])

export default __exports__